import { useEffect } from 'react';
import { getDestinosForExport } from '../lib/experienciasStorage';

const MESSAGE_TYPE = 'naviex-destinos-export';

/**
 * Página pública (sem login) usada pelo cliente em iframe para obter as opções de destino
 * (cidades de embarque das experiências publicadas) quando cliente e admin rodam em origens diferentes.
 * Envia os dados via postMessage para window.parent.
 */
export default function DestinosExportPage() {
  useEffect(() => {
    try {
      const destinos = getDestinosForExport();
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, destinos }, '*');
      }
    } catch (err) {
      if (window.parent !== window) {
        window.parent.postMessage({ type: MESSAGE_TYPE, destinos: [], error: String(err) }, '*');
      }
    }
  }, []);

  return (
    <div className="p-4 text-sm text-gray-500">
      Dados enviados ao cliente.
    </div>
  );
}

export { MESSAGE_TYPE };
